<template>
  <div class="corzo-mobile-header-wrap">
    <div class="corzo-mobile-header corzo-header-background corzo-style-slide corzo-sticky-mobile-navigation"
         id="corzo-mobile-header">
      <div class="corzo-mobile-header-container corzo-container clearfix">
        <div class="corzo-logo corzo-item-pdlr">
          <div class="corzo-logo-inner">
            <a class="corzo-fixed-nav-logo" href="index.html">
              <img src="../assets/logo.png" alt="" width="123" height="34" title="hp2-logo"/></a>
            <a class="corzo-orig-logo" href="index.html">
              <img src="../assets/logo.png" alt="" width="123" height="34" title="hp2-logo"/></a>
          </div>
        </div>
        <div class="corzo-mobile-menu-right">
          <div class="corzo-mobile-menu">
            <a class="corzo-mm-menu-button corzo-mobile-menu-button corzo-mobile-button-hamburger"
               href="#corzo-mobile-menu">
              <span></span>
            </a>
            <div class="corzo-mm-menu-wrap corzo-navigation-font" id="corzo-mobile-menu" data-slide="right" style="z-index: 100;">
              <ul id="menu-main-navigation" class="m-menu">
                <li
                  class="menu-item menu-item-home current-menu-item page_item page-item-12613 current_page_item current-menu-ancestor current-menu-parent current_page_parent current_page_ancestor menu-item-has-children">
                  <a href="index.html" aria-current="page">首页</a>
                </li>
                <li class="menu-item menu-item-has-children">
                  <a v-on:click="goto('about')">关于匯德</a>
                </li>
                <li class="menu-item menu-item-has-children">
                  <a v-on:click="goto('services/1')">匯德服务</a>
                  <ul class="sub-menu">
                    <li class="menu-item">
                      <a v-on:click="goto('services/1')">离岸家族服务</a></li>
                    <li class="menu-item">
                      <a v-on:click="goto('services/2')">跨境企业服务</a></li>
                    <li class="menu-item">
                      <a v-on:click="goto('services/3')">离岸资产配置</a></li>
                    <li class="menu-item">
                      <a v-on:click="goto('services/4')">海外家族办公室设立</a></li>
                  </ul>
                </li>
<!--                <li class="menu-item menu-item-has-children">-->
<!--                  <a href="index.html#/">新闻中心</a>-->
<!--                  <ul class="sub-menu">-->
<!--                    <li class="menu-item">-->
<!--                      <a href="index.html#/">公司动态</a></li>-->
<!--                    <li class="menu-item">-->
<!--                      <a href="index.html#/">离岸课堂</a></li>-->
<!--                  </ul>-->
<!--                </li>-->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeader',
  methods: {
    goto (path) {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      location.href = '#/' + path
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MobileHeader.vue